._controls_1xh4v_1 {
  display: flex;
  justify-content: right;
  margin-top: 12px; }
  ._controls__left_1xh4v_5 {
    display: flex;
    justify-content: space-between;
    gap: 12px; }
